let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b84Ec")).then(() => parcelRequire('c21c0'));